export const translations = {
  "en-US": {
    departure: "Check out",
    arrival: "Check in",
  },
  "it-IT": {
    departure: "Check out",
    arrival: "Check in",
  },
  "es-ES": {
    departure: "Check out",
    arrival: "Check in",
  },
  "nb-NO": {
    departure: "Avreise",
    arrival: "Ankomst",
  },
  "no-NO": {
    departure: "Avreise",
    arrival: "Ankomst",
  },
  "de-DE": {
    departure: "Check out",
    arrival: "Check in",
  },
  "fr-FR": {
    departure: "Check out",
    arrival: "Check in",
  },
}